export const searchFieldOutlinedInputStyles = (theme) => ({
  '&:has(input[placeholder*="search" i]), &:has(input[aria-label*="search" i]), &:has(.MuiInputAdornment-positionStart svg[data-testid*="Search" i])':
    {
      height: 50,
      borderRadius: '30px',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.18)'
            : 'rgba(0,0,0,0.15)',
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      },

      '& .MuiInputBase-input': {
        color: theme.palette.text.primary,
      },

      '& .MuiInputBase-input::placeholder': {
        color:
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.72)'
            : 'rgba(0,0,0,0.65)',
        opacity: 1,
      },
    },
});
